<template>
	<div style="width: 100%">
		<!-- PC -->
		<div v-if="ifPc == 1">
			<div class="pcClass" @mouseenter="carouselEnter" @mouseleave="carouselLeave">
				<el-carousel trigger="click" height="900px" :interval="4000" arrow="never">
					<el-carousel-item v-for="(item,index) in bannerList">
						<div class="banner" @click="goToTab(index)" style="cursor: pointer;">
							<div class="bannerZoom">
								<el-image :src="item.src" fit="cover" style="width: 100%;height: 900px;z-index: 5;">
								</el-image>
							</div>
							<div
								style="height: 140px;top: 611px;left: 132px;z-index: 10;position: absolute;color: white;width: 100%;">
								<div style="height: 70px;line-height: 70px;font-size: 60px;font-weight: bold;">
									{{item.title}}
								</div>
								<div style="height: 59px;line-height: 59px;font-size: 50px;margin-top: 11px;width:60%;">
									{{item.detail}}
								</div>
							</div>
							<div class="bannerColor">
								<el-image :src="item.c" fit="cover" style="height: 100%;">
								</el-image>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>

			<div style="display: flex;flex-wrap: wrap;align-items: center;gap: 50px 100px;margin:120px 100px;">
				<el-image :src="item" v-for="item in companyList" fit="cover">
				</el-image>
			</div>

			<div style="display: flex;margin-left: 60px;margin-right: 60px;">
				<div style="margin-right: 60px;width:539px;">
					<div style="font-size: 50px;font-weight: bold;line-height: auto;">
						Operational and Process Excellence
					</div>
					<div style="font-size: 20px;line-height: 36px;margin-top: 20px;">
						Your company’s business architecture helps your organization deliver the right capabilities at
						the right time. Together, we’ll dive into your business operations across people, processes,
						technology and metrics to ensure you can create truly sustainable results.
					</div>
					<div style="margin-top: 45px;">
						<el-image @click="changePage('Contact')" src="/newImage/contactus.png"
							style="width: 242px;height: 48px;cursor: pointer;"></el-image>
					</div>
				</div>
				<div style="flex: 1;">
					<div style="position: relative;overflow: hidden;">
						<el-image src="/newImage/detail1.png" class="details" style="height: 700px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
			</div>

			<div style="display: flex;margin-left: 60px;margin-right: 60px;margin-top: 120px;">

				<div style="flex: 2;">
					<div style="position: relative;overflow: hidden;">
						<el-image src="/newImage/detail2.png" class="details" style="height: 700px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
				<div style="margin-left: 60px;flex:1;">
					<div style="font-size: 50px;font-weight: bold;line-height: auto;">
						Business Strategy
					</div>
					<div style="font-size: 20px;line-height: 36px;margin-top: 20px;">
						To guide your company toward its envisioned future, you need a road map.  We’ll help you
						understand your business and customer insights while developing a compelling vision, strategy
						and overall blueprint for driving competitive advantage.
					</div>
					<div style="margin-top: 45px;">
						<el-image @click="changePage('Contact')" src="/newImage/contactus.png"
							style="width: 242px;height: 48px;cursor: pointer;"></el-image>
					</div>
				</div>
			</div>


			<div style="position: relative;margin-top: 120px;">
				<el-image src="/newImage/support.png" style="height: 1002px;width: 100%;z-index:5;" fit="cover">
				</el-image>
				<div
					style="position:absolute;top:0px;left:10%;width:80%;height:100%;display: flex;z-index:10;align-items: center;">
					<div style="text-align: center;color:white;">
						<div style="font-size: 50px;font-weight: bold;line-height: auto;">
							Recruitment Support
						</div>
						<div style="font-size: 30px;margin-top: 20px;word-wrap: break-word;">
							Our staffing solutions link you to great jobs with the best companies on our easy to use
							online job search. <br> 
							Allow us to connect you with Employers that matches your skills and needs.
						</div>
					</div>
				</div>
			</div>

			<div id="tab1" style="position: relative;margin-top: 120px;padding:0px 60px;">
				<div style="width: 70%;display: inline-block;vertical-align: bottom;">
					<div style="font-size: 50px;font-weight: bold;line-height: auto;">
						Full-Stack Marketing Technology Solutions
					</div>
					<div style="font-size: 20px;margin-top: 20px;word-break: break-all;">
						We deliver integrated marketing tech services spanning customer‑centric analytics, dynamic email
						marketing, social media management, and holistic attribution—unifying data, automating
						workflows, and powering data‑driven campaign decisions.
					</div>
				</div>
				<div v-show="noButton" style="display: inline-block;width: 30%;text-align: right;">
					<el-image v-show="leftCheck" @click="scrollRight(1)" src="/newImage/left.png"
						style="height: 60px;width:60px;cursor: pointer;" fit="cover">
					</el-image>
					<el-image v-show="!leftCheck" @click="scrollRight(1)" src="/newImage/leftEnd.png"
						style="height: 60px;width:60px;cursor: pointer;" fit="cover">
					</el-image>

					<el-image v-show="rightCheck" @click="scrollRight(2)" src="/newImage/right.png"
						style="height: 60px;width:60px;margin-left: 20px;cursor: pointer;" fit="cover">
					</el-image>
					<el-image v-show="!rightCheck" @click="scrollRight(2)" src="/newImage/rightEnd.png"
						style="height: 60px;width:60px;margin-left: 20px;cursor: pointer;" fit="cover">
					</el-image>
				</div>
			</div>


			<div style="margin-top: 60px;">
				<div ref="scrollBox" @scroll="handleScroll" style="" class="scrollClass">
					<div class="stack"
						:style="'height: 700px;width: 500px;display: inline-block;vertical-align: top;margin-right: '+((index+1) == stackList.length?60:10)+'px;cursor: pointer;position: relative;'"
						v-for="(item,index) in stackList">
						<el-image :src="item.src" fit="cover" style="width: 100%;height: 700px;z-index: 10;">
						</el-image>
						<div
							style="position: absolute;z-index:12;bottom:0px;left:0px;height: 160px;width: 100%;backdrop-filter: blur(10px);background-color: rgba(255, 255, 255, 0.2);color:white;">
							<div style="margin: 20px 24px;">
								<div style="font-size: 30px;font-weight: bold;">{{item.title}}</div>
								<div style="font-size: 20px;margin-top: 20px;">
									<div style="white-space: normal;">{{item.d}}</div>
								</div>
							</div>
						</div>
						<div class="stackColor">
							<div style="position: absolute;z-index:12;bottom:0px;left:0px;width: 100%;color:white;">
								<div style="margin: 40px 34px;">
									<div style="font-size: 30px;font-weight: bold;">{{item.title}}</div>
									<div style="font-size: 20px;margin-top: 20px;line-height: 1.5;">
										<div style="white-space: normal;">{{item.detail}}</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>

			<div id="tab2" style="margin-top: 120px;background-color: #F6F6F6;display: flex;">

				<div style="width: 720px;height: 700px;">
					<div style="margin:140px 119px;">
						<div style="font-size: 50px;font-weight: bold;line-height: auto;">
							One-Stop Customs Solutions, Fast & Reliable
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 35px;">
							We offer expert and expedited same day Filing services to importers in order to ensure our
							clients' entries are processed and cleared efficiently. Timely processing is essential to
							avoid hefty penalties and customs release delays.
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 700px;">
					<div style="position: relative;overflow: hidden;">
						<el-image src="/newImage/trade1.png" class="details" style="height: 700px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
			</div>

			<div style="display: flex;height: auto;">
				<div style="flex: 1;height: auto;">
					<div style="position: relative;overflow: hidden;height: 100%;">
						<el-image src="/newImage/trade2.png" class="details" style="height: 100%;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
				<div style="width: 72%;height: auto;">
					<div style="margin:90px 120px;">
						<div style="font-size: 50px;font-weight: bold;line-height: auto;">
							Customs Clearance and Consultation
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 20px;">
							Our experienced professionals will ensure goods clear quickly and efficiently through our
							electronic customs clearance network. We’re committed to providing consistent, reliable
							services in a timely and professional manner.<br>
							Our customs experts can guide you through the complexity of:
						</div>

					</div>
					<div style="margin-top: 50px;margin-left: 110px;margin-bottom: 30px;">
						<div style="display: inline-block;vertical-align: top;width: 23%;height: 154px;">
							<div
								style="height: 154px;border-right: 1px solid #EEEEEE;border-bottom: 1px solid #EEEEEE;">
								<div style="margin-left: 10px;">
									<el-image src="/newImage/tradeicon1.png" style="height: 36px;width: 36px;"
										fit="cover">
									</el-image>
									<div style="font-size: 20px;line-height: 30px;margin-top: 20px;">
										Tariff classification
									</div>
								</div>
							</div>
						</div>
						<div style="display: inline-block;vertical-align: top;width: 28%;height: 154px;">
							<div
								style="height: 154px;border-right: 1px solid #EEEEEE;border-bottom: 1px solid #EEEEEE;">
								<div style="margin-left: 25%;">
									<el-image src="/newImage/tradeicon2.png" style="height: 36px;width: 36px;"
										fit="cover">
									</el-image>
									<div style="font-size: 20px;line-height: 30px;margin-top: 20px;">
										Valuation
									</div>
								</div>
							</div>
						</div>
						<div style="display: inline-block;vertical-align: top;width: 48%;">
							<div style="height: 154px;border-bottom: 1px solid #EEEEEE;">
								<div style="margin-left: 30%;">
									<el-image src="/newImage/tradeicon3.png" style="height: 36px;width: 36px;"
										fit="cover">
									</el-image>
									<div style="font-size: 20px;line-height: 30px;margin-top: 20px;">
										PGA requirements
									</div>
									<div style="font-size: 14px;color: #AAAAAA;">
										FDA, USDA, EPA, FCC, NHTSA, FWS etc.
									</div>
								</div>

							</div>
						</div>
						<div style="display: inline-block;vertical-align: top;width: 23%;height: 154px;">
							<div style="height: 154px;border-right: 1px solid #EEEEEE;">
								<div style="margin-left: 10px;padding-top: 35px;">
									<el-image src="/newImage/tradeicon4.png" style="height: 36px;width: 36px;"
										fit="cover">
									</el-image>
									<div style="font-size: 20px;line-height: 30px;margin-top: 20px;">
										Duty/tax recovery
									</div>
								</div>
							</div>
						</div>
						<div style="display: inline-block;vertical-align: top;width: 28%;height: 154px;">
							<div style="height: 154px;border-right: 1px solid #EEEEEE;">
								<div style="margin-left: 25%;padding-top: 35px;">
									<el-image src="/newImage/tradeicon5.png" style="height: 36px;width: 36px;"
										fit="cover">
									</el-image>
									<div style="font-size: 20px;line-height: 30px;margin-top: 20px;">
										Specific product
									</div>
									<div style="font-size: 20px;line-height: 30px;">
										requirements
									</div>
								</div>

							</div>
						</div>
						<div style="display: inline-block;vertical-align: top;width:48%;">
							<div style="height: 154px;">
								<div style="margin-left: 30%;padding-top: 35px;">
									<el-image src="/newImage/tradeicon6.png" style="height: 36px;width: 36px;"
										fit="cover">
									</el-image>
									<div style="font-size: 20px;line-height: 30px;margin-top: 20px;">
										Compliance Audits
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>

			</div>
			<div style="background-color: #F6F6F6;display: flex;">

				<div style="width: 720px;height: 700px;">
					<div style="margin:214px 101px;">
						<div
							style="font-size: 50px;font-weight: bold;line-height: auto;width: 110%;position: relative;left:-2%">
							Trucking and Delivery
						</div>
						<div style="font-size: 20px;line-height: 30px;margin-top: 35px;">
							Drayage and Delivery services are available upon customs and freight release of your goods.
							We possess the tools necessary to offer you our highly competitive rates with the best
							carriers in the industry.
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 700px;">
					<div style="position: relative;overflow: hidden;">
						<el-image src="/newImage/trade3.png" class="details" style="height: 700px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
			</div>
			<div id="tab3" style="margin-top: 100px;padding-bottom: 100px;">
				<div style="text-align: center;font-size: 50px;font-weight: bold;">
					Strategy, Operations, Talent — All for Your Growth
				</div>
				<div style="margin: 100px 8% 0px 8%;">
					<div
						style="width: 59.4%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;">
						<div style="padding:49px 48px 49px 48px;">
							<div style="font-size: 24px;font-weight: bold;line-height: 34px;">
								Operational and Process Excellence
							</div>
							<div
								style="font-size: 20px;line-height: 30px;color:#999999;margin-top: 10px;height: 150px;">
								Your company’s business architecture helps your organization deliver the right
								capabilities at the right time.  Together, we’ll dive into your business operations
								across people, processes, technology and metrics to ensure you can create truly
								sustainable results.
							</div>
							<div style="margin-top: 37px;">
								<el-image src="/newImage/consulting1.png" style="height: 357px;width: 100%;"
									fit="cover">
								</el-image>
							</div>
						</div>
					</div>
					<div
						style="width: 39.4%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;margin-left: 1.2%;">
						<div style="padding:49px 48px 49px 48px;">
							<div style="font-size: 24px;font-weight: bold;line-height: 34px;">
								Business Strategy
							</div>
							<div
								style="font-size: 20px;line-height: 30px;color:#999999;margin-top: 10px;height: 150px;">
								To guide your company toward its envisioned future, you need a road map.  We’ll help you
								understand your business and customer insights while developing a compelling vision,
								strategy and overall blueprint for driving competitive advantage.
							</div>
							<div style="margin-top: 37px;">
								<el-image src="/newImage/consulting2.png" style="height: 357px;width: 100%;"
									fit="cover">
								</el-image>
							</div>
						</div>
					</div>

					<div
						style="width: 36%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;margin-top:1.2%;">
						<div style="padding:49px 48px 49px 48px;">
							<div style="font-size: 24px;font-weight: bold;line-height: 34px;">
								Staffing Services
							</div>
							<div
								style="font-size: 20px;line-height: 30px;color:#999999;margin-top: 10px;height: 120px;">
								Joblogic-X has recruiting specialists in many areas of business to meet your complete
								office needs. We offer employment for Administration, Engineering, and much more.
							</div>
							<div style="margin-top: 37px;">
								<el-image src="/newImage/consulting3.png" style="height: 357px;width: 100%;"
									fit="cover">
								</el-image>
							</div>
						</div>
					</div>
					<div
						style="width: 62.5%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;margin-left: 1.2%;margin-top:1.2%;">
						<div style="padding:49px 48px 49px 48px;">
							<div style="font-size: 24px;font-weight: bold;line-height: 34px;">
								Recruitment Support
							</div>
							<div
								style="font-size: 20px;line-height: 30px;color:#999999;margin-top: 10px;height: 120px;">
								Our staffing solutions link you to great jobs with the best companies on our easy to use
								online job search.  Allow us to connect you with Employers that matches your skills and
								needs.
							</div>
							<div style="margin-top: 37px;">
								<el-image src="/newImage/consulting4.png" style="height: 357px;width: 100%;"
									fit="cover">
								</el-image>
							</div>
						</div>
					</div>

				</div>
			</div>



		</div>

		<!-- 手机 -->
		<div v-if="ifPc == 2">
			<div class="phoneClass" style="position: relative;">
				<el-carousel trigger="click" height="200px" :interval="4000" arrow="never">
					<el-carousel-item v-for="(item,index) in bannerList">
						<div class="banner" @click="goToTab(index)" style="cursor: pointer;position: relative;">
							<div class="bannerZoom">
								<el-image :src="item.src" fit="cover" style="width: 100%;height: 200px;z-index: 5;">
								</el-image>
							</div>
							<div
								style="height: 35px;top: 140px;left: 30px;z-index: 10;position: absolute;color: white;width: 100%;">
								<div style="height: 16px;line-height: 16px;font-size: 14px;font-weight: bold;">
									{{item.title}}
								</div>
								<div style="height: 14px;line-height: 14px;font-size: 12px;margin-top: 6px;width:60%;">
									{{item.detail}}
								</div>
							</div>
							<div class="phoneBannerColor">
								<el-image :src="item.c" fit="cover" style="height: 100%;">
								</el-image>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>


			<div style="margin:35px 22px 35px 22px;">
				<el-image src="../../newImage/company/phoneCompany.png" fit="cover" style="width: 100%;">
				</el-image>
			</div>

			<div style="display: flex;margin-left: 15px;margin-right: 15px;background-color: #4B45B9;">
				<div style="padding-right: 19px;position: relative;height: 160px;width:160px;">
					<div style="position: absolute;bottom:0px;padding:19px 19px 10px 19px;color:white;height: auto;">
						<div style="font-size: 12px;font-weight: bold;line-height: auto;height: auto;">
							Operational and Process Excellence
						</div>
						<div style="font-size: 8px;line-height: 1.5;margin-top: 5px;height: auto;">
							Your company’s business architecture helps your organization deliver the right capabilities
							at
							the right time. Together, we’ll dive into your business operations across people, processes,
							technology and metrics to ensure you can create truly sustainable results.
						</div>
					</div>
				</div>
				<div style="flex:2;height: 160px;">
					<div style="position: relative;overflow: hidden;height: 160px;">
						<el-image src="/newImage/detail1.png" class="details" style="height: 160px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
			</div>
			<div style="display: flex;margin-left: 15px;margin-right: 15px;background-color: #4B45B9;">
				<div style="flex:2;height: 160px;">
					<div style="position: relative;overflow: hidden;height: 160px;">
						<el-image src="/newImage/detail2.png" class="details" style="height: 160px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
				<div style="padding-right: 19px;position: relative;height: 160px;width:160px;">
					<div style="position: absolute;bottom:0px;padding:19px 19px 10px 19px;color:white;height: auto;">
						<div style="font-size: 12px;font-weight: bold;line-height: auto;height: auto;">
							Business Strategy
						</div>
						<div style="font-size: 8px;line-height: 1.5;margin-top: 5px;height: auto;">
							To guide your company toward its envisioned future, you need a road map.  We’ll help you
							understand your business and customer insights while developing a compelling vision,
							strategy and overall blueprint for driving competitive advantage.
						</div>
					</div>
				</div>
			</div>

			<div style="position: relative;margin-top: 20px;">
				<el-image src="/newImage/support.png" style="height: 230px;width: 100%;z-index:5;" fit="cover">
				</el-image>
				<div
					style="position:absolute;top:0px;left:10%;width:80%;height:100%;display: flex;z-index:10;align-items: center;">
					<div style="text-align: center;color:white;">
						<div style="font-size: 16px;font-weight: bold;line-height: auto;">
							Recruitment Support
						</div>
						<div style="font-size: 10px;margin-top: 5px;word-wrap: break-word;">
							Our staffing solutions link you to great jobs with the best companies on our easy to use
							online job search.Allow us to connect you with Employers that matches your skills and needs.
						</div>
					</div>
				</div>
			</div>

			<div id="tab1" style="position: relative;margin-top: 20px;padding:0px 15px;">
				<div style="vertical-align: bottom;">
					<div style="font-size: 16px;font-weight: bold;line-height: auto;">
						Full-Stack Marketing Technology Solutions
					</div>
					<div style="font-size: 10px;margin-top: 2px;word-break: break-all;">
						We deliver integrated marketing tech services spanning customer‑centric analytics, dynamic email
						marketing, social media management, and holistic attribution—unifying data, automating
						workflows, and powering data‑driven campaign decisions.
					</div>
				</div>
			</div>

			<div style="margin-top: 10px;">
				<div
					style="overflow-x: auto;overflow-y: hidden;white-space: nowrap;scrollbar-width: none;-ms-overflow-style: none;margin-left: 15px;">
					<div :style="'height: 170px;width: 114px;display: inline-block;vertical-align: top;margin-right: '+((index+1) == stackList.length?15:4)+'px;cursor: pointer;position: relative;'"
						v-for="(item,index) in stackList">
						<el-image :src="item.srcc" fit="cover" style="width: 100%;height: 170px;z-index: 10;">
						</el-image>
						<div
							style="position: absolute;z-index:12;top:0px;left:0px;color:white;height: 100%;width: 100%;">
							<div style="margin:5px;white-space: normal;">
								<div
									style="font-size: 10px;font-weight: bold;word-wrap: break-word;word-break: break-all;overflow-wrap: break-word;">
									<div v-for="item in item.title2">
										{{item}}
									</div>
								</div>
								<div style="font-size: 6px;margin-top: 6px;line-height: 1.4;">
									<div style="white-space: normal;">{{item.detail}}</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>

			<div id="tab2" style="margin-top: 30px;background-color: #F6F6F6;display: flex;">

				<div style="width: 165px;height: 150px;">
					<div style="margin:15px 10px;">
						<div style="font-size: 16px;font-weight: bold;line-height: auto;">
							One-Stop Customs Solutions, Fast & Reliable
						</div>
						<div style="font-size: 6px;line-height: 10px;margin-top: 10px;">
							We offer expert and expedited same day Filing services to importers in order to ensure our
							clients' entries are processed and cleared efficiently. Timely processing is essential to
							avoid hefty penalties and customs release delays.
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 150px;">
					<div style="position: relative;overflow: hidden;">
						<el-image src="/newImage/trade1.png" class="details" style="height: 150px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
			</div>

			<div style="display: flex;height: auto;">
				<div style="flex: 1;height: auto;">
					<div style="position: relative;overflow: hidden;height: 100%;">
						<el-image src="/newImage/trade2.png" class="details" style="height: 100%;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
				<div style="width: 72%;height: auto;">
					<div style="margin:10px 15px 0px 15px;">
						<div style="font-size: 16px;font-weight: bold;line-height: auto;">
							Customs Clearance and Consultation
						</div>
						<div style="font-size: 6px;line-height: 8px;margin-top: 5px;">
							Our experienced professionals will ensure goods clear quickly and efficiently through our
							electronic customs clearance network. We’re committed to providing consistent, reliable
							services in a timely and professional manner.<br>
							Our customs experts can guide you through the complexity of:
						</div>

					</div>
					<div style="margin-top: 10px;margin-left: 11px;margin-bottom: 15px;">
						<el-image src="/newImage/customs.png" style="width: 85%;" fit="cover">
						</el-image>
					</div>

				</div>

			</div>

			<div style="background-color: #F6F6F6;display: flex;">

				<div style="width: 165px;height: 150px;">
					<div style="margin:15px 10px;">
						<div style="font-size: 16px;font-weight: bold;line-height: auto;">
							Trucking and Delivery
						</div>
						<div style="font-size: 6px;line-height: 10px;margin-top: 10px;">
							Drayage and Delivery services are available upon customs and freight release of your goods.
							We possess the tools necessary to offer you our highly competitive rates with the best
							carriers in the industry.
						</div>

					</div>
				</div>
				<div style="flex: 1;height: 150px;">
					<div style="position: relative;overflow: hidden;">
						<el-image src="/newImage/trade3.png" class="details" style="height: 150px;width: 100%;"
							fit="cover">
						</el-image>
					</div>
				</div>
			</div>


			<div id="tab3" style="margin-top: 22px;padding-bottom: 22px;">
				<div style="text-align: center;font-size: 16px;font-weight: bold;margin-left: 10px;margin-right: 10px;">
					Strategy, Operations, Talent — All for Your Growth
				</div>
				<div style="margin: 10px 10px 0px 10px">
					<div
						style="width: 56.4%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;">
						<div style="padding:11px;">
							<div style="font-size: 8px;font-weight: bold;line-height: 8px;">
								Operational and Process Excellence
							</div>
							<div style="font-size: 8px;line-height: 10px;color:#999999;margin-top: 2px;height: 80px;">
								Your company’s business architecture helps your organization deliver the right
								capabilities at the right time.  Together, we’ll dive into your business operations
								across people, processes, technology and metrics to ensure you can create truly
								sustainable results.
							</div>
							<div style="margin-top: 5px;">
								<el-image src="/newImage/consulting1.png" style="height: 65px;width: 100%;" fit="cover">
								</el-image>
							</div>
						</div>
					</div>
					<div
						style="width: 42.4%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;margin-left: 1.2%;">
						<div style="padding:11px;">
							<div style="font-size: 8px;font-weight: bold;line-height: 8px;">
								Business Strategy
							</div>
							<div style="font-size: 8px;line-height: 10px;color:#999999;margin-top: 2px;height: 80px;">
								To guide your company toward its envisioned future, you need a road map.  We’ll help you
								understand your business and customer insights while developing a compelling vision,
								strategy and overall blueprint for driving competitive advantage.
							</div>
							<div style="margin-top: 5px;">
								<el-image src="/newImage/consulting2.png" style="height: 65px;width: 100%;" fit="cover">
								</el-image>
							</div>
						</div>
					</div>

					<div
						style="width: 39%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;margin-top:1.2%;">
						<div style="padding:11px;">
							<div style="font-size: 8px;font-weight: bold;line-height: 8px;">
								Staffing Services
							</div>
							<div style="font-size: 8px;line-height: 10px;color:#999999;margin-top: 2px;height: 70px;">
								Joblogic-X has recruiting specialists in many areas of business to meet your complete
								office needs. We offer employment for Administration, Engineering, and much more.
							</div>
							<div style="margin-top: 5px;">
								<el-image src="/newImage/consulting3.png" style="height: 65px;width: 100%;" fit="cover">
								</el-image>
							</div>
						</div>
					</div>
					<div
						style="width: 59.5%;background-color: #F6F6F6;border-radius: 12.31px;display: inline-block;vertical-align: top;margin-left: 1.2%;margin-top:1.2%;">
						<div style="padding:11px;">
							<div style="font-size: 8px;font-weight: bold;line-height: 8px;">
								Recruitment Support
							</div>
							<div style="font-size: 8px;line-height: 10px;color:#999999;margin-top: 2px;height: 70px;">
								Our staffing solutions link you to great jobs with the best companies on our easy to use
								online job search.  Allow us to connect you with Employers that matches your skills and
								needs.
							</div>
							<div style="margin-top: 5px;">
								<el-image src="/newImage/consulting4.png" style="height: 65px;width: 100%;" fit="cover">
								</el-image>
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>


	</div>
</template>
<script>
	import utils from "../utils/index.js";
	export default {
		name: "App",
		data() {
			return {
				innerHeight: window.innerHeight,
				ifPc: window.innerWidth > window.innerHeight ? 1 : 2, // 默认根据宽高判断 1PC 2手机
				bannerList: [{
						src: '/newImage/banner1.png',
						c: '/newImage/banner1c.png',
						title: "MARKETING SOLUTION",
						detail: "Right Strategies Implementation and Success.",
					},
					{
						src: '/newImage/banner2.png',
						c: '/newImage/banner2c.png',
						title: "IMPORT & EXPORT SERVICE",
						detail: "Connecting You to Endless Possibilities.",
					},
					{
						src: '/newImage/banner3.png',
						c: '/newImage/banner3c.png',
						title: "CONSULTING & STAFFING",
						detail: "Talent Never Waste, it Always Give You Something Worthy.",
					}
				],
				ifHover: false,
				companyList: [
					"/newImage/company/company1.png",
					"/newImage/company/company2.png",
					"/newImage/company/company3.png",
					"/newImage/company/company4.png",
					"/newImage/company/company5.png",
					"/newImage/company/company6.png",
					"/newImage/company/company7.png",
					"/newImage/company/company8.png",
					"/newImage/company/company9.png",
					"/newImage/company/company10.png",
					"/newImage/company/company11.png",
					"/newImage/company/company12.png",
					"/newImage/company/company13.png",
					"/newImage/company/company14.png",
					"/newImage/company/company15.png",
				],
				stackList: [{
						src: '/newImage/stack1.png',
						srcc: '/newImage/stack1c.png',
						title: "Customer-Centric Analytics",
						title2: ["Customer-Centric", "Analytics"],
						d: "Unified data & systems for complete campaign insights.",
						detail: "We can program APIs to integrate your existing enterprise applications and consolidate all your siloed data, giving you a holistic view of your campaigns and their effects on your bottom line. We design centralized dashboards, side-by-side A/B testing modules, and dynamic, easily sharable KPI visualizations with \"what-if\" analysis tools that offer big-picture views of campaign success metrics.",
					},
					{
						src: '/newImage/stack2.png',
						srcc: '/newImage/stack2c.png',
						title: "Dynamic Email Marketing",
						title2: ["Dynamic Email", "Marketing"],
						d: "We build powerful, interactive email marketing platforms.",
						detail: "We build feature-rich email marketing platforms that you can use to create eye-catching, engaging corporate emails with HTML and CSS, or with intuitive visual editing tools. Other built-in features can include segment-able contact lists, automated response planners, engagement trackers, automated opt-in/op-out reactions, drip marketing planning modules, tools for creating inquiry forms and other interactive elements, and much more.",
					},
					{
						src: '/newImage/stack3.png',
						srcc: '/newImage/stack3c.png',
						title: "Social Media Marketing",
						title2: ["Social Media", "Marketing"],
						d: "Integrated social media marketing tools for scheduling, analytics and API connectivity.",
						detail: "We develop and integrate social media marketing applications for collaborating with coworkers to strategize cohesive social campaigns. We program features for automating regularly scheduled posts, mining relevant data, analyzing user engagement, alerting SMMs to responses and tracking brand mentions. We've worked with social media platform APIs from LinkedIn, Facebook, Twitter and more, and know how to seamlessly interface our platforms with theirs.",
					},
					{
						src: '/newImage/stack4.png',
						srcc: '/newImage/stack4c.png',
						title: "Holistic Marketing Attribution",
						title2: ["Holistic Marketing", "Attribution"],
						d: "Unified cross-channel data analytics with AI-driven attribution and forecasting.",
						detail: "We automate the gathering of data from traditional advertising networks, social media, email campaigns, CRM, and other channels before using algorithms custom-written by our data analysts to determine your marketing successes and failures. Our systems allow for single and multiple-touch attribution models, as well as fractional and algorithmic ones. We can also integrate machine learning technology to help with campaign forecasting.",
					},
				],
				maxScroll: 0,
				leftCheck: false,
				rightCheck: true,
				noButton: true,
			};
		},
		computed: {},
		methods: {
			goToTab(index) {
				if (index == 0) {
					document.getElementById('tab1').scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
				if (index == 1) {
					document.getElementById('tab2').scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
				if (index == 2) {
					document.getElementById('tab3').scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}

			},
			changePage(page) {
				this.$router.push(page);
			},
			carouselEnter() {
				this.ifHover = true;
			},
			carouselLeave() {
				this.ifHover = false;
			},
			// 监听滚动事件
			handleScroll(event) {},
			scrollRight(type) {
				if (this.$refs.scrollBox != null) {
					const scrollBox = this.$refs.scrollBox;
					const startLeft = scrollBox.scrollLeft;

					const targetLeft = startLeft + (type == 1 ? -510 : 510);

					// 添加滚动结束监听
					const handleScrollEnd = () => {

						if (type == 1) {

							if (parseInt(scrollBox.scrollLeft) < scrollBox.scrollWidth - scrollBox.clientWidth) {
								this.rightCheck = true;
							} else {
								this.rightCheck = false;
							}

							if (scrollBox.scrollLeft > 0) {
								this.leftCheck = true;
							} else {
								this.leftCheck = false;
							}

						} else {
							if (parseInt(scrollBox.scrollLeft) == scrollBox.scrollWidth - scrollBox.clientWidth - 1 ||
								parseInt(scrollBox.scrollLeft) == scrollBox.scrollWidth - scrollBox.clientWidth) {
								this.rightCheck = false;
							} else {
								this.rightCheck = true;
							}

							if (scrollBox.scrollLeft > 0) {
								this.leftCheck = true;
							} else {
								this.leftCheck = false;
							}


						}

						scrollBox.removeEventListener('scroll', handleScroll);
					};

					// 滚动事件处理
					const handleScroll = () => {
						// 防抖处理，避免频繁触发
						clearTimeout(scrollBox.scrollTimer);
						scrollBox.scrollTimer = setTimeout(handleScrollEnd, 100);
					};

					// 开始监听滚动
					scrollBox.addEventListener('scroll', handleScroll);

					// 执行滚动
					scrollBox.scrollTo({
						left: targetLeft,
						behavior: 'smooth'
					});
				}


			},
		},
		mounted() {
			if (this.$refs.scrollBox != null) {
				if (this.$refs.scrollBox.clientWidth > ((this.stackList.length * 510) + 50)) {
					//宽度足够  不需要按钮
					this.noButton = false;
				}
			}

		}
	};
</script>

<style lang="less">
	.text-ellipsis-2 {
		display: -webkit-box;
		display: box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		/* 标准属性 */
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.scrollClass {
		overflow-x: auto;
		overflow-y: hidden;
		white-space: nowrap;
		scrollbar-width: none;
		-ms-overflow-style: none;
		margin-left: 60px;
	}


	.banner {
		width: 100%;
		height: 900px;
		position: relative;
	}

	.stack {}

	.stackColor {
		width: 100%;
		height: 700px;
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 5;
		width: 100%;
		background-color: #4B45B9;
	}

	.stack:hover .stackColor {
		width: 100%;
		height: 700px;
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 15;
		width: 100%;
		background-color: #4B45B9;
	}


	.bannerZoom {
		transform: scale(1);
		/* 放大10% */
		transform-origin: center center;
		/* 缩放中心点 */
		transition: all 0.3s;
	}

	.banner:hover .bannerZoom {
		transform: scale(1.1);
		/* 放大10% */
		transform-origin: center center;
		/* 缩放中心点 */
		transition: all 0.3s;
	}

	.details {
		transform: scale(1);
		/* 放大10% */
		transform-origin: center center;
		/* 缩放中心点 */
		transition: all 0.3s;
	}

	.details:hover {
		transform: scale(1.1);
		/* 放大10% */
		transform-origin: center center;
		/* 缩放中心点 */
		transition: all 0.3s;
	}


	.phoneBannerColor {
		position: absolute;
		left: 0px;
		top: 0px;
		height: 400px;
		z-index: 8;
		width: 68.385%;
		transition: all 0.3s;
	}

	.bannerColor {
		position: absolute;
		left: -68.385%;
		top: 0px;
		height: 900px;
		z-index: 8;
		width: 68.385%;
		transition: all 0.3s;
	}

	.banner:hover .bannerColor {
		width: 68.385%;
		position: absolute;
		left: 0px;
		top: 0px;
		height: 900px;
		z-index: 8;
		transition: all 0.3s;
	}

	.pcClass .el-carousel__button {
		height: 16px !important;
		width: 120px !important;
		border-radius: 16px !important;
		margin-left: 6px !important;
		margin-right: 6px !important;
	}

	.pcClass .el-carousel__indicator.is-active button {
		background-color: rgba(0, 0, 0, 0.6);
	}

	.phoneClass .el-carousel__button {
		height: 5px !important;
		width: 15px !important;
		border-radius: 16px !important;
		margin-left: 3px !important;
		margin-right: 3px !important;
	}

	.phoneClass .el-carousel__indicator.is-active button {
		background-color: rgba(0, 0, 0, 0.6);
	}

	.phoneClass .el-carousel__indicators--horizontal {
		bottom: -11px !important;
	}
</style>